module.exports = __webpack_public_path__ + "img/fi-rr-test.d07e4b12.svg";